import { PhoneNumber, randomDNI } from '@nemuru-eng/js-api-client';
import { v4 as uuidv4 } from 'uuid';

import { DefaultDialCodeOption } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/constants/DefaultDialCodeOption';
import { EmptyDialCodeOption } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/constants/EmptyDialCodeOption';
import { getDialCodeItemFromList } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/utils/getDialCodeItemFromList';
import { developOptions } from '@/config/developOptions';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const useContactInformationDefaultValues = () => {
  const {
    state: { orderReference1, orderReference2, customerData, birthDate },
  } = useApplicationContext();

  let defaultValues = {
    firstName: '',
    lastName: '',
    documentNumber: '',
    dialCode: DefaultDialCodeOption,
    phoneNumber: '',
    email: '',
    birthDate: undefined as Date | undefined,
    orderReference1: '',
  };

  if (developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES) {
    defaultValues = {
      ...defaultValues,
      firstName: 'Ramon',
      lastName: 'Borras Pinilla',
      documentNumber: randomDNI(),
      email: 'ramon.borras@nemuru.com',
      dialCode: DefaultDialCodeOption,
      phoneNumber: '687090145',
      birthDate: new Date('1996-03-19'),
      orderReference1: uuidv4().split('-')[4],
    };
  }

  const phoneNumber = customerData?.phoneNumber ? new PhoneNumber(customerData.phoneNumber) : undefined;

  return {
    defaultValues: {
      firstName: customerData?.firstName || defaultValues.firstName,
      lastName: customerData?.lastName || defaultValues.lastName,
      documentNumber: customerData?.documentNumber || defaultValues.documentNumber,
      dialCode: phoneNumber
        ? getDialCodeItemFromList(phoneNumber.countryCallingCode) ?? EmptyDialCodeOption
        : defaultValues.dialCode,
      phoneNumber: phoneNumber?.nationalNumber || defaultValues.phoneNumber,
      email: customerData?.email || defaultValues.email,
      birthDate: birthDate || defaultValues.birthDate,
      orderReference1: orderReference1 || defaultValues.orderReference1,
      orderReference2: orderReference2,
    },
  };
};
